import { FunctionComponent } from 'react';

import styles from './CopyRight.module.scss';
import { THEME } from 'src/enums/theme';
import classNames from 'classnames';

interface CopyRightProps {
  text: string;
  theme?: THEME;
}

export const CopyRight: FunctionComponent<CopyRightProps> = ({ text, theme = THEME.LIGHT }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={classNames(styles.copyRightWrapper, styles[theme])}>
      <span>{`© 1996-${currentYear} `}</span>
      <span className={styles.copyRightText}>{text}</span>
    </div>
  );
};
